// Mikro-helpery DOM (UI gry jest w HTML/CSS nad canvasem – ostre teksty i natywne zachowanie dotyku na telefonach).
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Record<string, string> = {}, ...children: (Node | string)[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'class') el.className = v; else el.setAttribute(k, v);
  }
  for (const c of children) el.append(c);
  return el;
}

export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}

export const ui = (): HTMLElement => document.getElementById('ui')!;

export function toast(text: string, kind: 'info' | 'good' | 'bad' = 'info', ms = 2600): void {
  let box = document.querySelector<HTMLElement>('.toasts');
  if (!box) { box = h('div', { class: 'toasts' }); ui().append(box); }
  const t = h('div', { class: `toast ${kind}` }, text);
  box.append(t);
  setTimeout(() => t.classList.add('out'), ms);
  setTimeout(() => t.remove(), ms + 400);
}
